

<ng-container *ngIf="company; else loading">
    <div class="container">
        <div class="row pt--64 pb--64">
            <div class="col-12">
                <div translate class="text-primary mat-h4">Key e focus</div>
                <h2 translate>page.dashboard.identity_title</h2>
                <div class="text-default mb--24" [innerHTML]="'page.dashboard.identity_abstract' | translate"></div>
                <company-overview [company]="company"></company-overview>
            </div>
            <div class="col-12">
                <company-balance [company]="company" [ateco]="ateco"></company-balance>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #loading>
    <ng-container *ngIf="missingCompanyData$(); else skeletonLoader">
        <h2 translate>Dati finanziari mancanti</h2> 
    </ng-container>
</ng-template>
<ng-template #skeletonLoader>
    <ngx-mare-skeleton [grid]="'2x3'"></ngx-mare-skeleton>

</ng-template>